import React from 'react';
import sharedStyles from '../DefineMyCommunity.module.scss';
import { CalciteButton } from '@esri/calcite-components-react';


type clearProps = {
  handleClick: (event: React.MouseEvent) => void,
}

const ClearResultsButton = ({handleClick}: clearProps) => (
  <CalciteButton className={sharedStyles.MapButton} color='blue' appearance ='outline' iconStart='reset' onClick={handleClick}>Clear Results</CalciteButton>
);

export default ClearResultsButton;
